export default __webpack_public_path__ + "static/media/icon-transferencia.2b94039d.svg";